import React from 'react';
// import { Link } from 'react-router-dom';
import {Icon} from '../../Common/Icon';
import cx from '../../../styles';

/*
type: link | icon
 */
const NextPrevSection = ({month, className, type = "link", locale = "en", t}) => {
    return (
        <div className={cx("next-prev-section", (type == "link" ? "type-link" : "type-icon")) + " " + className}>
            <aside className={cx("left")}>
                {
                    month > 1 &&
                    <a href={`/tracker/baby/${month - 1}?lng=${locale}`} aria-label="go to previous month">
                        {
                            type == "icon"
                            ?
                                <Icon name="chevron-left-regular-md" color="#fff" />
                                :
                                <div className={cx("link-txt-wrap", "flex", "flex-center")}>
                                    <Icon name="chevron-left-regular-md" />
                                    <span>{t('prev')}</span>
                                </div>
                        }
                    </a>
                }
            </aside>

            <aside className={cx("right")}>
                {
                    month < 48 &&
                    <a href={`/tracker/baby/${month + 1}?lng=${locale}`} aria-label="go to next month">
                        {
                            type == "icon"
                            ?
                                <Icon name="chevron-right-regular-md" color="#fff" />
                                :
                                <div className={cx("link-txt-wrap", "flex", "flex-center")}>
                                    <span>{t('next')}</span>
                                    <Icon name="chevron-right-regular-md" />
                                </div>
                        }
                    </a>
                }
            </aside>                    
        </div>
    )
}

const BabyView = ({data, locale,t}) => {
    const image = data.milestone_image ? data.milestone_image : data.image;
    
    return (
        <div className={cx("baby-view")}>
            <div className={cx("shadow-card", "no-pad", "tracker-calendar-card")}>
                <div className={cx("img-wrap")}>
                    <div className={cx("img-blur-wrap")}>
                        <div style={{backgroundImage:'url('+image+')'}}></div>
                        <img src={image} alt="BabyView" loading="lazy"/>
                    </div>

                    <NextPrevSection month={data.month} type="icon" locale={locale} t={t}/>
                </div>
                
                <div className={cx("baby-heading")} >
                    <div>{"Month " + data.month}</div>
                    <h1>{data.heading}</h1>
                </div>

                <div className={cx("baby-description")}>
                    <h2><span>Description</span></h2>
                    <div dangerouslySetInnerHTML={{__html: data.description}}></div>
                </div>

                <NextPrevSection month={data.month} locale={locale} t={t}/>
            </div>
        </div>
    );
}

export default BabyView;
